import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { personApi } from '../../services/personApi';
import { CreatePerson } from '../../dtos/Persons/index';
import { personKeys } from './useGetPerson';

export function useCreatePerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePerson) => personApi.create(data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully created person');
        queryClient.invalidateQueries({ queryKey: personKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to create person'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to create person'}`);
    },
  });
}
